import { IResourceItem } from 'app/context/resource/types';
import { pickResource } from '../pick-resource';

/**
 * Picks the data provider name based on the provided name or fallbacks to resource definition, or `default`.
 */
export const pickDataProvider = (
  resourceName?: string,
  dataProviderName?: string,
  resources?: IResourceItem[]
) => {
  if (dataProviderName) {
    return dataProviderName;
  }

  const resource = pickResource(resourceName, resources);

  const meta = resource?.meta;

  if (meta?.dataProviderName) {
    return meta.dataProviderName;
  }

  return 'default';
};
